import { useTheme, type Appearance } from '../../lib/theme';
import { Icon } from './Icon';
import styles from './PublicAppearanceSelector.module.css';

const OPTIONS: ReadonlyArray<{ value: Appearance; label: string; icon: string }> = [
  { value: 'system', label: 'System appearance', icon: 'sun-moon' },
  { value: 'light', label: 'Light appearance', icon: 'sun' },
  { value: 'dark', label: 'Dark appearance', icon: 'moon' },
];

export function PublicAppearanceSelector() {
  const { appearance, setAppearance } = useTheme();

  return (
    <div className={styles.selector} role="group" aria-label="Page appearance">
      {OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          className={styles.option}
          data-active={appearance === option.value}
          onClick={() => setAppearance(option.value)}
          aria-label={option.label}
          aria-pressed={appearance === option.value}
          title={option.label}
        >
          <Icon name={option.icon} size={15} />
        </button>
      ))}
    </div>
  );
}
